const setting={
    SETTING_TITLE:"تنظیمات",
    ABOUT_US:"درباره ما",
    PROFILE:"حساب کاربری",
    EXIT:"خروج",
}


export default setting